import { useCallback, useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import DashboardLayout from "../../../layout/Layout";
import { FaEdit, FaTrash } from "react-icons/fa";
import Table, { Td } from "../../../common/Table";
import Pagination from "../../../common/Pagination";
import Api from "../../../api/api";
import Loader from "../../../common/Loader";
import Input from "../../../common/Input";
import Button from "../../../common/Button";
import { jsonToQueryParams } from "../../../helpers/functions";

const columns = ["Question", "Answer", "Video", "Date", "Actions"];

const AdminQuiz = () => {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const page = parseInt(params.get("page") || 1);
  const limit = parseInt(params.get("limit") || 10);

  const [query, setQuery] = useState("");
  const [data, setData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  const handleSearch = event => {
    const { value } = event.target;
    setQuery(value);
  };

  /* eslint-disable no-restricted-globals */
  const handleDeleteUser = async id => {
    if (!id) return;
    const isOK = confirm("Are you sure you want to delete this record?");
    if (isOK) {
      setData(prev => prev.filter(user => user._id !== id));
      setTotalData(prev => (prev > 0 ? prev - 1 : prev));
      await Api.deleteQuiz(id);
    }
  };

  const getQuizes = useCallback(
    async ({ search, page, limit }) => {
      try {
        const res = await Api.allQuiz(search, page, limit);
        if (res?.status === 200) {
          setData(res.data.data?.records);
          setTotalPages(res.data.data?.totalPages);
          setTotalData(res.data.data?.totalRecords);
        }
      } catch (error) {
        console.log(error.message);
      } finally {
        setIsLoading(false);
      }
    },
    [setData],
  );

  useEffect(() => {
    const _query = jsonToQueryParams({ page: 1, limit, search: query || "" });
    history.push(`${location.pathname}?${_query}`);
  }, [query]);

  useEffect(() => {
    getQuizes({ search: query, page, limit });
  }, [location.pathname, location.search]);

  return (
    <>
      <DashboardLayout title={`Quizes (${totalData})`}>
        <div className="flex justify-between items-end mb-4">
          <Input
            value={query}
            onChange={handleSearch}
            placeholder="Search quiz..."
          />
          <Button onClick={() => history.push("/admin/dashboard/quiz/_new")}>Add Quiz</Button>
        </div>
        <Table columns={columns}>
          {!isLoading &&
            data &&
            data?.map(itm => (
              <tr>
                <Td>{itm?.question}</Td>
                <Td>{itm?.answer}</Td>
                <Td>
                  <Link
                    to={itm?.video}
                    className="underline"
                  >
                    {itm?.video}
                  </Link>
                </Td>
                <Td>{itm?.date}</Td>
                <Td>
                  <div className="flex items-center gap-3">
                    <Link to={`quiz/${itm?._id}`}>
                      <FaEdit
                        size={18}
                        className="cursor-pointer fill-blue-500"
                      />
                    </Link>
                    <FaTrash
                      size={18}
                      className="cursor-pointer fill-red-500"
                      onClick={() => handleDeleteUser(itm?._id)}
                    />
                  </div>
                </Td>
              </tr>
            ))}
        </Table>

        <br />
        {isLoading ? (
          <div className="grid place-items-center">
            <Loader />
          </div>
        ) : (
          <Pagination totalPages={totalPages} />
        )}
      </DashboardLayout>
    </>
  );
};

export default AdminQuiz;
